import { render } from "./PriceListHistoryLog.vue?vue&type=template&id=b0cad188&scoped=true"
import script from "./PriceListHistoryLog.vue?vue&type=script&lang=js"
export * from "./PriceListHistoryLog.vue?vue&type=script&lang=js"

import "./PriceListHistoryLog.vue?vue&type=style&index=0&id=b0cad188&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0cad188"]])

export default __exports__